import { z } from 'zod'

export const orgInternSearchSchema = z.object({
  search: z.string().catch(''),
  status: z.coerce
    .number()
    .pipe(z.union([z.literal(0), z.literal(1), z.literal(2)]))
    .catch(2),
  eduOrgId: z.string().catch(''),
  supervisorId: z.string().catch(''),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z
    .enum(['intern', 'eduOrg', 'internship', 'date', 'supervisor', 'lastRecord'])
    .catch('lastRecord'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})
export type OrgInternSearch = z.infer<typeof orgInternSearchSchema>
export const defaultOrgInternSearch = orgInternSearchSchema.parse({})
export const orgInternRequest = (search: OrgInternSearch) => ({
  ...search,
  search: search.search || undefined,
  eduOrgId: search.eduOrgId || undefined,
  supervisorId: search.supervisorId || undefined,
  sortBy: `${search.sortBy}${search.direction === 'desc' ? '-' : ''}`,
})
